/**
 * Created by JIocb on 03.07.2017.
 */

module Factive.Core {
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import DragonBonesButton = Factive.Game.DragonBonesButton;
    import Panel = Factive.Core.Panel;
    import StorageManager = Factive.Core.StorageManager;
    import ISoundManager = Factive.Core.ISoundManager;
    import StorageManagerConstants = Factive.Core.StorageManagerConstants;
    import EventBusConstants = Factive.Core.EventBusConstants;
    import EventBus = Factive.Core.EventBus;
    import SoundConstants = Factive.Game.SoundConstants;

    export class SettingsPanel extends Panel {

        private _lm: LocalizationManager;
        private _armature: dragonBones.Armature;
        private _eb: EventBus;
        private _buttonById:any;

        public get scrimVisible(): boolean {
            return true;
        }

        constructor(dc: DependenciesContainer, name: any) {
            "use strict";
            super(dc, name);
            this._lm = this._dc.get("LocalizationManager");
            this._eb = this._dc.get("EventBus");

        };

        protected build() {
            "use strict";
            this._armature = dragonBones.PixiFactory.factory.buildArmature("PanelSettings");
            this.addChild(<PIXI.DisplayObject>this._armature.display);
            dragonBones.WorldClock.clock.add(this._armature);
            this._armature.animation.play("appear", 1);

            let btnArmature;
            this._buttonById = {};
            let buttons: Array<{name:string;text:string}> = [
                {
                    name:"BtnSoundOn",
                    text:this._lm.getText("sound_on_settings_button")
                }, {
                    name:"BtnSoundOff",
                    text:this._lm.getText("sound_off_settings_button")
                }, {
                    name:"BtnHelp",
                    text:this._lm.getText("help_settings_button")
                }, {
                    name:"BtnQuit",
                    text:this._lm.getText("quit_settings_button")
                }, {
                    name:"BtnClose",
                    text:null
                }];

            for (let i = 0; i < buttons.length; i++) {
                let btnSlot = this._armature.getSlot(buttons[i].name);
                if (btnSlot) {
                    btnArmature = btnSlot.childArmature;

                    if(buttons[i].text){
                        let label = new PIXI.Text(buttons[i].text, <PIXI.TextStyle>{
                            fontFamily: 'Regular',
                            fontSize: 14* this._assetScale,
                            fill: '#FFFFFF',
                            align: "left"
                        });
                        label.anchor.set(0,.5);
                        label.x = 30 * this._assetScale;
                        label.addListener("pointerup",this["handlePress" + buttons[i].name], this);
                        label.interactive = true;
                        label.buttonMode = true;

                        btnArmature.display.addChild(label);
                    }

                    let btn = new DragonBonesButton(btnArmature, this._dc);
                    this._buttonById[buttons[i].name] = btn;
                    btn.addPressListener(this["handlePress" + buttons[i].name], this);
                }
            }
            this.checkSoundBtn();

            this._armature.display.scale.x = this._armature.display.scale.y = 2;
        }

        protected handlePressBtnSoundOn(): void {
            this.signal.dispatch("press_sound_on");
            this.changeSound();
        };

        protected handlePressBtnSoundOff(): void {
            this.signal.dispatch("press_sound_off");
            this.changeSound();
        };

        protected changeSound(): void {

            let ls: StorageManager = <StorageManager>this._dc.get("StorageManager");
            let mute: boolean = ls.loadData(StorageManagerConstants.MUTE_SOUNDS) == "1";
            mute = !mute;

            ls.saveData(StorageManagerConstants.MUTE_SOUNDS, mute ? "1" : "0");

            let sm: ISoundManager = <ISoundManager>this._dc.get("SoundManager");
            sm.mute(mute);

            //let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
            //sm.playSound(SoundConstants.MUSIC_LOOP, true);

            this.checkSoundBtn();
        };

        protected checkSoundBtn(): void {
            let ls: StorageManager = <StorageManager>this._dc.get("StorageManager");
            let mute: boolean = ls.loadData(StorageManagerConstants.MUTE_SOUNDS) == "1";

            if (this._armature.getSlot("BtnSoundOn"))
                this._armature.getSlot("BtnSoundOn").childArmature.display.visible = !mute;

            if (this._armature.getSlot("BtnSoundOff"))
                this._armature.getSlot("BtnSoundOff").childArmature.display.visible = mute;
        };

        protected handlePressBtnHelp(): void {
            this._eb.dispatch(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_HELP, EventBusConstants.TOPIC_UI);
        };

        protected handlePressBtnQuit(): void {
            this._eb.dispatch(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_QUIT, EventBusConstants.TOPIC_UI);
        };

        protected handlePressBtnClose(): void {
            this._eb.dispatch(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_CLOSE, EventBusConstants.TOPIC_UI);
        };

        public reset(): void {

            if (this._buttonById) {
                var keys = Object.keys(this._buttonById);
                var l: number = keys.length;
                for (var i: number = 0; i < l; i++) {
                    var btn: DragonBonesButton = this._buttonById[keys[i]];
                    btn.removePressListener(this["handlePress" + keys[i]], this);
                    btn.destroy();
                }
            }

            this._buttonById = null;

            if(this._armature) {
                dragonBones.WorldClock.clock.remove(this._armature);
                this.removeChild(<PIXI.DisplayObject>this._armature.display);
                this._armature = null;
            }
            super.reset();
        };

        public destroy(): void {
            super.destroy();
        };


        public resize(aspectRatio: string){
            super.resize(aspectRatio);
            if(this._armature == null){
                return;
            }
            if(this._aspectRatio == "landscape")
            {
                this._eb.dispatch(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_CLOSE, EventBusConstants.TOPIC_UI);
            }
        }
    }

};


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Panel/SettingsPanel.ts